import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Key, AlertTriangle } from 'lucide-react';

export const ProLoginGate = ({
  email, setEmail, loginCode, setLoginCode,
  handleProLogin, handleResendCode, loading, navigate, loginNotice,
}) => (
  <div className="max-w-md mx-auto" data-testid="pro-login-gate">
    <Card className="card-tech p-8">
      <div className="text-center mb-6">
        <Key className="w-16 h-16 text-green-500 mx-auto mb-4" />
        <h2 className="text-3xl font-bold glow-text">PRO ACCESS</h2>
        <p className="text-green-300 mt-2">Enter your email and access code from your purchase.</p>
      </div>
      {loginNotice && (
        <div className="mb-5 flex items-start gap-3 p-4 rounded border border-yellow-500/50 bg-yellow-500/10"
          role="alert" data-testid="pro-login-throttle-notice">
          <AlertTriangle className="w-5 h-5 text-yellow-400 shrink-0 mt-0.5" />
          <p className="text-yellow-300 text-sm">{loginNotice}</p>
        </div>
      )}
      <div className="space-y-4">
        <div>
          <label className="block text-green-400 text-sm font-semibold mb-2">PayPal Email</label>
          <Input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email used for Pro purchase"
            className="bg-black/50 border-green-500/30 text-green-300 h-12" data-testid="pro-login-email" />
        </div>
        <div>
          <label className="block text-green-400 text-sm font-semibold mb-2">Access Code</label>
          <Input value={loginCode} onChange={e => setLoginCode(e.target.value)} placeholder="Your payment access code"
            className="bg-black/50 border-green-500/30 text-green-300 h-12" data-testid="pro-login-code" />
          <p className="text-green-500/60 text-xs mt-1">Received after Pro purchase on the success page.</p>
        </div>
        <Button onClick={handleProLogin} disabled={loading} className="btn-primary w-full py-4" data-testid="pro-login-button">
          {loading ? 'Verifying...' : 'Access Pro Dashboard'}
        </Button>
        <button onClick={handleResendCode} disabled={loading} type="button"
          className="w-full text-center text-green-400 text-sm underline hover:text-green-300 disabled:opacity-50"
          data-testid="pro-resend-code">
          Forgot your access code? Send it to your email
        </button>
      </div>
      <div className="text-center mt-4">
        <p className="text-green-500/60 text-sm">Don't have Pro? <button onClick={() => navigate('/pricing')} className="text-green-400 underline">Upgrade now</button></p>
      </div>
    </Card>
  </div>
);
